import type { Permission } from '@/core/user/permission.model';

export interface AppRouteInfo {
  label: string;
  icon: string;
}

export interface AppRouteData {
  topbar?: AppRouteInfo;
  sidebar?: AppRouteInfo;
  permission?: Permission;
}

const ACTIVITY_ROUTE_INFO = {
  topbar: {
    label: 'nav.activities',
    icon: 'icons/topbar/activity_icon.svg',
  },
  sidebar: {
    label: 'nav.activities',
    icon: 'icons/phosphor/regular/squares-four.svg',
  },
} as const;

export const APP_ROUTES_CONFIG = {
  brokerActivity: {
    ...ACTIVITY_ROUTE_INFO,
    permission: 'LIST_KPI',
  },
  salesActivity: {
    ...ACTIVITY_ROUTE_INFO,
    permission: 'LIST_BROKERS_KPI',
  },
  opportunities: {
    topbar: {
      label: 'nav.opportunities',
      icon: 'icons/topbar/opportunities_icon.svg',
    },
    sidebar: {
      label: 'nav.opportunities',
      icon: 'icons/phosphor/regular/note.svg',
    },
    permission: 'LIST_OPPORTUNITIES',
  },
  newOpportunity: {
    permission: 'CREATE_OPPORTUNITY',
  },
  opportunityDetail: {
    permission: 'GET_OPPORTUNITY',
  },
  users: {
    topbar: {
      label: 'nav.users',
      icon: 'icons/topbar/users_icon.svg',
    },
    sidebar: {
      label: 'nav.users',
      icon: 'icons/phosphor/regular/users.svg',
    },
    permission: 'LIST_USERS',
  },
  roles: {
    topbar: {
      label: 'nav.roles',
      icon: 'icons/topbar/key_icon.svg',
    },
    sidebar: {
      label: 'nav.roles',
      icon: 'icons/phosphor/regular/key.svg',
    },
    permission: 'LIST_ROLES',
  },
} as const satisfies Record<string, AppRouteData>;
